import sensors from 'sa-sdk-javascript'

export default {
  track (eventName, options) {
    sensors.track(eventName, Object.assign({
      sys_product_name: 'alpha_school',
      sys_platform: 'web',
    }, options))
  },
  autoTrackSinglePage: () => sensors.quick('autoTrackSinglePage', {
    sys_product_name: 'alpha_school',
    sys_platform: 'web',
  }),
  saLogin: sensors.login,
}
